function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.1750001)",
  id: "g877"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect836",
  d: "M 5.780128,278.74664 H 9.0365384 V 281.596 H 5.780128 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rect836-3",
  d: "m 4.1519227,276.97308 h 6.5128203 v 2.38416 H 4.1519227 Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path853-6",
  d: "m 11.034375,287.69336 a 0.53138491,0.53138491 0 1 0 0,1.0625 h 3.896486 a 0.53138491,0.53138491 0 1 0 0,-1.0625 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path853-67",
  d: "m 10.770659,280.69688 c -3.9752533,0 -7.2088177,3.23174 -7.2088186,7.207 -3.7e-6,3.97526 3.2335616,7.20882 7.2088186,7.20882 3.975259,0 7.207004,-3.23356 7.207,-7.20882 0,-3.97526 -3.231746,-7.207 -7.207,-7.207 z m 0,0.98409 c 3.442558,0 6.222904,2.78035 6.222905,6.22291 3e-6,3.44256 -2.780343,6.2229 -6.222905,6.2229 -3.4425602,0 -6.2229075,-2.78034 -6.2229038,-6.2229 9e-7,-3.44256 2.7803464,-6.22291 6.2229038,-6.22291 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path896",
  d: "m 14.493361,283.69922 a 0.52921956,0.52921956 0 0 0 -0.363281,0.16016 l -4.1542987,4.15429 a 0.52921956,0.52921956 0 1 0 0.7480477,0.74805 l 4.154298,-4.1543 a 0.52921956,0.52921956 0 0 0 -0.384766,-0.9082 z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
});

var SvgMapTimer = function SvgMapTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-timer.02556066.svg";
export { ForwardRef as ReactComponent };